/**
 * Resident routes moved from /admission/* to /workflow/*. Links already sent by email keep
 * pointing at the old path for as long as their token lives, so those paths are still mapped
 * rather than falling through to the catch-all, which would drop the token in the query string.
 */
export const LEGACY_ADMISSION_PATH = "/admission";

export const toWorkflowPath = (pathname: string): string =>
  pathname.replace(/^\/admission(?=\/|$)/, "/workflow");
